import { ValueOf } from '../utilities/types';

const reportCategories = {
  REGULATORY: 'regulatory',
  SCENARIO: 'scenario',
  RISK: 'risk',
  REQUESTS_PINGS_CASES: 'requestsPingsCases',
  ENTITIES: 'entities',
} as const;

export type ReportCategories = ValueOf<typeof reportCategories>;

export default reportCategories;
